import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import BreadCrumb from "Common/BreadCrumb";
import Select from "react-select";

// Icon
import { Pencil, UploadCloud } from "lucide-react";

// Image
import productImg03 from "assets/images/product/img-03.png";
import Dropzone from "react-dropzone";
import { generateUniqueId } from "utils/uuid";
import { getAzureBlobStorageBackend } from "helpers/azure_helper";
import { useDispatch, useSelector } from "react-redux";
import { addDiamonds as onAddDiamonds } from "slices/diamond/thunk";
import { toast } from "react-toastify";
import { getSuppliers as onGetSuppliers } from "slices/thunk";

type selectFiles = {
  preview: string;
  formattedSize: string;
  file: Blob;
};

type provider = {
  label: string;
  value: string;
  data: any;
};

export type status = {
  label: string;
  value: string;
};

export type addDiamondsBody = {
  excelUrl: string;
  inventory: {
    name: string;
    supplierId: string;
    status: string;
  };
};
const AddInventory = () => {
  const [selectFiles, setSelectFiles] = useState<selectFiles[]>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<provider | null>(
    null
  );
  const [inventoryName, setInventoryName] = useState<string>("");
  const [selectedStatus, setSelectedStatus] = useState<status | null>(null);
  const [isUploadingInventory, setIsUploadingInventory] =
    useState<boolean>(false);
  const [supplierOptions, setSupplierOptions] = useState<provider[]>([]);

  const dispatch = useDispatch<addDiamondsBody | any>();
  const navigate = useNavigate();

  const { suppliers } = useSelector((state: any) => state.Users);

  const handleAcceptfiles = (files: any) => {
    files?.map((file: any) => {
      return Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
        file: new Blob([file], { type: file.type }),
      });
    });
    setSelectFiles(files);
  };

  const formatBytes = (bytes: any, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  // const supplierOptions = [
  //   { value: "skyExports", label: "Sky Exports", data: {} },
  //   {
  //     value: "irisGrown",
  //     label: "Iris Grown",
  //     data: {},
  //   },
  // ];

  const statusOptions = [
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ];

  const acceptConfig = {
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
      ".xlsx",
    ],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template": [
      ".xltx",
    ],
    "application/vnd.ms-excel-template": [".xlt"],
    "application/vnd.ms-excel.sheet.macroEnabled.12": [".xlsm"],
    "application/vnd.ms-excel.template.macroEnabled.12": [".xltm"],
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12": [".xlsb"],
    "text/csv": [".csv"],
    "text/tab-separated-values": [".tab"],
  };

  const handleUploadInventoryFile = async () => {
    let url: string = "";
    const containerName =
      process.env.REACT_APP_AZURE_BLOB_INVENTORY_BACKUP_CONTAINER;
    const blobName = generateUniqueId() + selectedSupplier?.value;
    const file = selectFiles[0]?.file;
    if (containerName && blobName && file) {
      const azureBlobStorageBackend = getAzureBlobStorageBackend();
      url = (await azureBlobStorageBackend?.uploadExcelFile(
        containerName,
        blobName,
        file
      )) as string;
    } else {
      toast.error("Fill all the details!");
      return "";
    }
    return url;
  };

  const handleProviderChange = async (selectedSupplier: any) => {
    setSelectedSupplier(selectedSupplier as provider);
  };

  // This function store diamond inventory in db
  const handleStoreInventory = async () => {
    setIsUploadingInventory(true);
    const inventoryFileUrl = await handleUploadInventoryFile();
    if (!inventoryFileUrl) return toast.error("can't find inventory file");
    if (!selectedSupplier?.data?._id)
      return toast.error("can't find supplierId");
    if (!selectedStatus) return toast.error("can't find inventory status");

    const body: addDiamondsBody = {
      excelUrl: inventoryFileUrl,
      inventory: {
        name: inventoryName,
        supplierId: selectedSupplier.data._id,
        status: selectedStatus.value,
      },
    };

    // call api for store inventory in db
    await dispatch(onAddDiamonds(body));
    setIsUploadingInventory(false);
    handleReset();
    navigate("/inventories");
  };

  const handleReset = () => {
    setSelectFiles([]);
    setSelectedSupplier(null);
    setSelectedStatus(null);
  };

  const handleSupplierOptions = () => {
    const formattedSuppliers = suppliers.length
      ? suppliers.map((supplier: any) => {
          return {
            label: supplier.name,
            value: supplier.name,
            data: supplier,
          };
        })
      : [];
    setSupplierOptions(formattedSuppliers);
  };

  useEffect(() => {
    dispatch(onGetSuppliers());
  }, []);

  useEffect(() => {
    suppliers && handleSupplierOptions();
  }, [suppliers]);

  return (
    <React.Fragment>
      <BreadCrumb title="Add Diamonds" pageTitle="Products" />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-9">
          <div className="card">
            <div className="card-body">
              {/* <h6 className="mb-4 text-15">Create Product</h6> */}

              <form
                action="#!"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleStoreInventory();
                }}
              >
                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                  <div className="xl:col-span-6">
                    <label
                      htmlFor="categorySelect"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Supplier
                    </label>
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={supplierOptions}
                      isSearchable={true}
                      name="providerSelect"
                      id="providerSelect"
                      value={selectedSupplier}
                      onChange={handleProviderChange}
                      placeholder="Select Supplier"
                      isDisabled={isUploadingInventory}
                    />
                  </div>
                  <div className="xl:col-span-6">
                    <label
                      htmlFor="inventoryNameInput"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Inventory Name
                    </label>
                    <input
                      type="text"
                      id="inventoryNameInput"
                      className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      placeholder="Inventory Name"
                      value={inventoryName}
                      onChange={(e) => {
                        setInventoryName(e.target.value);
                      }}
                      required
                      disabled={isUploadingInventory}
                    />
                  </div>
                  <div className="lg:col-span-2 xl:col-span-12">
                    <label
                      htmlFor="genderSelect"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Upload Diamonds Sheet
                    </label>

                    <Dropzone
                      onDrop={(acceptfiles: any) => {
                        handleAcceptfiles(acceptfiles);
                      }}
                      accept={acceptConfig}
                      maxFiles={1}
                      disabled={isUploadingInventory}
                    >
                      {({ getRootProps }: any) => (
                        <div className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer dropzone border-slate-300 dark:bg-zink-700 dark:border-zink-500 dropzone2 disabled:opacity-50">
                          <div
                            className="w-full py-5 text-lg text-center dz-message needsclick"
                            {...getRootProps()}
                          >
                            <div className="mb-3">
                              <UploadCloud className="block size-12 mx-auto text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500" />
                            </div>
                            <h5 className="mb-0 font-normal text-slate-500 dark:text-zink-200 text-15">
                              Drag and drop your diamonds sheet or{" "}
                              <Link to="#!">browse</Link> your diamonds sheet
                            </h5>
                          </div>
                        </div>
                      )}
                    </Dropzone>
                    <ul
                      className="flex flex-wrap mb-0 gap-x-5"
                      id="dropzone-preview2"
                    >
                      {(selectFiles || [])?.map((file: any, index: number) => {
                        return (
                          <li className="mt-5" id="dropzone-preview-list2">
                            <div className="border rounded border-slate-200 dark:border-zink-500">
                              <div className="p-2 text-center">
                                {/* <div>
                                  <div className="p-2 mx-auto rounded-md size-14 bg-slate-100 dark:bg-zink-600">
                                    <img
                                      className="block w-full h-full rounded-md"
                                      src={file.preview}
                                      alt={file.name}
                                    />
                                  </div>
                                </div> */}
                                <div className="pt-3">
                                  <h5 className="mb-1 text-15" data-dz-name>
                                    {file.path}
                                  </h5>
                                  <p
                                    className="mb-0 text-slate-500 dark:text-zink-200"
                                    data-dz-size
                                  >
                                    {file.formattedSize}
                                  </p>
                                  <strong
                                    className="error text-danger"
                                    data-dz-errormessage
                                  ></strong>
                                </div>
                                <div className="mt-2">
                                  <button
                                    data-dz-remove
                                    className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20 disabled:opacity-50 disabled:cursor-not-allowed"
                                    onClick={() => {
                                      const newImages = [...selectFiles];
                                      newImages.splice(index, 1);
                                      setSelectFiles(newImages);
                                    }}
                                    disabled={isUploadingInventory}
                                  >
                                    Delete
                                  </button>
                                </div>
                              </div>
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>

                  <div className="xl:col-span-4">
                    <label
                      htmlFor="productVisibility"
                      className="inline-block mb-2 text-base font-medium"
                    >
                      Status
                    </label>
                    <Select
                      className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                      options={statusOptions}
                      isSearchable={false} // To disable search
                      name="statusSelect"
                      id="statusSelect"
                      value={selectedStatus}
                      onChange={(selectedStatus) => {
                        setSelectedStatus(selectedStatus);
                      }}
                      placeholder="Select status"
                      isDisabled={isUploadingInventory}
                    />
                  </div>
                </div>
                <div className="flex justify-end gap-2 mt-4">
                  <button
                    type="reset"
                    className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-700 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={(e) => {
                      e.preventDefault();
                      handleReset();
                    }}
                    disabled={isUploadingInventory}
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20 disabled:opacity-50 disabled:cursor-wait"
                    disabled={isUploadingInventory}
                  >
                    Upload Diamonds
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* <div className="xl:col-span-3">
          <div className="card sticky top-[calc(theme('spacing.header')_*_1.3)]">
            <div className="card-body">
              <h6 className="mb-4 text-15">Product Card Preview</h6>

              <div className="px-5 py-8 rounded-md bg-sky-50 dark:bg-zink-600">
                <img src={productImg03} alt="" className="block mx-auto h-44" />
              </div>

              <div className="mt-3">
                <h5 className="mb-2">
                  $145.99{" "}
                  <small className="font-normal line-through">299.99</small>
                </h5>
                <h6 className="mb-1 text-15">Fastcolors Typography Men</h6>
                <p className="text-slate-500 dark:text-zink-200">
                  Men's Fashion
                </p>
              </div>
              <h6 className="mt-3 mb-2 text-15">Colors</h6>
              <div className="flex flex-wrap items-center gap-2">
                <div>
                  <input
                    id="selectColorPre1"
                    className="inline-block size-5 align-middle border rounded-full appearance-none cursor-pointer bg-sky-500 border-sky-500 checked:bg-sky-500 checked:border-sky-500 disabled:opacity-75 disabled:cursor-default"
                    type="checkbox"
                    value="color1"
                    name="selectColorPre"
                  />
                </div>
                <div>
                  <input
                    id="selectColorPre2"
                    className="inline-block size-5 align-middle bg-orange-500 border border-orange-500 rounded-full appearance-none cursor-pointer checked:bg-orange-500 checked:border-orange-500 disabled:opacity-75 disabled:cursor-default"
                    type="checkbox"
                    value="color2"
                    name="selectColorPre"
                    defaultChecked
                  />
                </div>
                <div>
                  <input
                    id="selectColorPre3"
                    className="inline-block size-5 align-middle bg-green-500 border border-green-500 rounded-full appearance-none cursor-pointer checked:bg-green-500 checked:border-green-500 disabled:opacity-75 disabled:cursor-default"
                    type="checkbox"
                    value="color3"
                    name="selectColorPre"
                  />
                </div>
                <div>
                  <input
                    id="selectColorPre4"
                    className="inline-block size-5 align-middle bg-purple-500 border border-purple-500 rounded-full appearance-none cursor-pointer checked:bg-purple-500 checked:border-purple-500 disabled:opacity-75 disabled:cursor-default"
                    type="checkbox"
                    value="color4"
                    name="selectColorPre"
                  />
                </div>
              </div>

              <h6 className="mt-3 mb-2 text-15">Colors</h6>
              <div className="flex flex-wrap items-center gap-2">
                <div>
                  <input
                    id="selectSizePreXS"
                    className="hidden peer"
                    type="checkbox"
                    value="XS"
                    name="selectSizePre"
                  />
                  <label
                    htmlFor="selectSizePreXS"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 peer-checked:bg-custom-50 dark:peer-checked:bg-custom-500/20 peer-checked:border-custom-300 dark:peer-checked:border-custom-700 peer-disabled:bg-slate-50 dark:peer-disabled:bg-slate-500/15 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    XS
                  </label>
                </div>
                <div>
                  <input
                    id="selectSizePreS"
                    className="hidden peer"
                    type="checkbox"
                    value="S"
                    name="selectSizePre"
                  />
                  <label
                    htmlFor="selectSizePreS"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 peer-checked:bg-custom-50 dark:peer-checked:bg-custom-500/20 peer-checked:border-custom-300 dark:peer-checked:border-custom-700 peer-disabled:bg-slate-50 dark:peer-disabled:bg-slate-500/15 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    S
                  </label>
                </div>
                <div>
                  <input
                    id="selectSizePreM"
                    className="hidden peer"
                    type="checkbox"
                    value="M"
                    name="selectSizePre"
                  />
                  <label
                    htmlFor="selectSizePreM"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 peer-checked:bg-custom-50 dark:peer-checked:bg-custom-500/20 peer-checked:border-custom-300 dark:peer-checked:border-custom-700 peer-disabled:bg-slate-50 dark:peer-disabled:bg-slate-500/15 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    M
                  </label>
                </div>
                <div>
                  <input
                    id="selectSizePreL"
                    className="hidden peer"
                    type="checkbox"
                    value="L"
                    name="selectSizePre"
                  />
                  <label
                    htmlFor="selectSizePreL"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 peer-checked:bg-custom-50 dark:peer-checked:bg-custom-500/20 peer-checked:border-custom-300 dark:peer-checked:border-custom-700 peer-disabled:bg-slate-50 dark:peer-disabled:bg-slate-500/15 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    L
                  </label>
                </div>
                <div>
                  <input
                    id="selectSizePreXL"
                    className="hidden peer"
                    type="checkbox"
                    value="XL"
                    name="selectSizePre"
                  />
                  <label
                    htmlFor="selectSizePreXL"
                    className="flex items-center justify-center size-8 text-xs border rounded-md cursor-pointer border-slate-200 dark:border-zink-500 peer-checked:bg-custom-50 dark:peer-checked:bg-custom-500/20 peer-checked:border-custom-300 dark:peer-checked:border-custom-700 peer-disabled:bg-slate-50 dark:peer-disabled:bg-slate-500/15 peer-disabled:border-slate-100 dark:peer-disabled:border-slate-800 peer-disabled:cursor-default peer-disabled:text-slate-500 dark:peer-disabled:text-zink-200"
                  >
                    XL
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default AddInventory;
